module.exports = __webpack_public_path__ + "static/media/save-time.d002be69.svg";